// Add your custom JS here.
import $ from 'jquery';
import carousel from "./carousel";
import mobileNav from './mobile-nav';
import restaurantFilter from "./restaurant-filter"


var slickCarousel = $('.hero-carousel');
var restaurantList = $('.restaurant-list');
var mobileNavMenu = $('.main-menu');


// Check if element we want to execute js on exists on page. If not, do nothing to avoid console logs
if (slickCarousel) {
    carousel.init();
}

if (restaurantList) {
    restaurantFilter.init();
}

if (mobileNavMenu) {
    mobileNav.init();
}
